import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { RemoteAction } from '../../remote-action';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { ServiceRemoteActionBuilder } from '../service-remote-action-builder';
import { Servicejob } from 'src/app/_model/servicejob';
import { ServicejobIdRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/servicejob-id-remote-action-builder-service-step/servicejob-id-remote-action-builder-service-step';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';
import { ServicejobsService } from 'src/app/_services/servicejobs/logic/servicejobs.service';
import { GpsRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/gps-remote-action-builder-service-step/gps-remote-action-builder-service-step';
import { LocationService } from 'src/app/_services/location/location.service';

export class PresendJobIdentificationRemoteActionBuilder extends ServiceRemoteActionBuilder {
  constructor(
    appService: AppService,
    credentialsService: CredentialsService,
    clientStateService: ClientStateService,
    serviceJobsService: ServicejobsService,
    locationService: LocationService,
    private logger?: LoggingService
  ) {
    super(
      appService,
      credentialsService,
      {
        endpoint: 'jobidentification',
        authenticationRequired: true,
        fifo: false,
        cachable: false,
        data: {
          testonly: true
        },
        customTimeoutMs: 15000,
      },
      [
        new ServicejobIdRemoteActionBuilderServiceStep(clientStateService, serviceJobsService, logger),
        new GpsRemoteActionBuilderServiceStep(locationService, logger),
      ],
      async (data: any) => {
        this.logger.log(
          this.constructor.name,
          ' Executing post reorder sjob generate function'
        );
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    let ra = await super.generateRemoteAction(dataValues);
    // Post processing of remote action
    return ra;
  }
}
